import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DatasetMarkdownPanelAll from './DatasetMarkdownPanelAll';

const DatasetMarkdownPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DatasetMarkdownPanelAll, narrow: DatasetMarkdownPanelAll }}
    onChange={onChange}
  />
);

export default DatasetMarkdownPanel;
